import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFractureGreenSizeS from './IconFractureGreen_size_s';

const props: CreateIconArguments = {
  l: IconFractureGreenSizeS,
  m: IconFractureGreenSizeS,
  s: IconFractureGreenSizeS,
  xs: IconFractureGreenSizeS,
  name: 'IconFractureGreen',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
